// extracted by mini-css-extract-plugin
export default {"tabContent":"A7xEcZuHd9"};